<template>
    <script type="application/ld+json">
    {
    "@context": "http://schema.org",
    "@type": "Product",
    "description": "{{product.description ? product.description.replace(/<(?:.|\n)*?>/gm, ''): ''}}",
    "name": "{{product.title}}",
    "image": "{{product.images && product.images.length > 0 ? imageUrl(product.images[0].sizes, 'large') : ''}}",
    "brand": "{{product.brand}}",
    "gtin13": "{{product.bar_code}}",
    "sku": {{product.id}}
    }
    </script>
</template>

<script>
import {imageUrl} from '@/utils'
//This gives google/search engines more information about products
export default {
  name: 'ProductMicrodata',
  props: ["product"],
  methods:{
      imageUrl: imageUrl
  }
}

</script>
